import { HttpClient, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FullProductResponseDto, ProductResponseDto } from 'app/models/product-response-dto';
import { ProductDataDto } from 'app/models/product-data-dto';

export interface UpdateStatusDto {
  published?: boolean;
  featured?: boolean;
  todaydeals?: boolean;
  bestSeller?: boolean;
  isNotVisibleOnSite?: boolean;
  isNagtiveStockEnable?: boolean;  
}

export interface UpdateStatusResponseDto {
  success?: boolean;
  message?: string;
}
export interface SimpleProduct {
  id: number;
  name: string;
  thumbnail_image: string;
}

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private http:HttpClient) { }
  private get apiUrl(): string {
    const base = localStorage.getItem('apiURL');
    if (!base) throw new Error('apiURL not ready');
    return base + "/api/v2";
  }

 getProducts(
  page: number = 0,
  storeId: number = 1,
  userId: number = 1,
  languageCode: string = 'en',
  discountFilter: ProductDiscountFilter = ProductDiscountFilter.All,
  imageFilter: ProductImageFilter = ProductImageFilter.All,
  negativeStockFilter: ProductNegativeStockFilter = ProductNegativeStockFilter.All,
  bestSellerFilter: ProductBestSellerFilter = ProductBestSellerFilter.All,
  publishedFilter: ProductPublishedFilter = ProductPublishedFilter.All
): Observable<ProductResponseDto> {

  const params = new HttpParams()
    .set('page', page.toString())
    .set('storeId', storeId.toString())
    .set('userId', userId.toString())
    .set('languageCode', languageCode)
    .set('discountFilter', discountFilter.toString())
    .set('imageFilter', imageFilter.toString())
    .set('negativeStockFilter', negativeStockFilter.toString())
    .set('bestSellerFilter', bestSellerFilter.toString())
    .set('publishedFilter', publishedFilter.toString());

  return this.http.get<ProductResponseDto>(
    `${this.apiUrl}/products`,
    { params }
  );
}
 getProductsByIds( ids: number[] = [], languageCode: string = 'en'): Observable<SimpleProduct[]> {
    return this.http.post<SimpleProduct[]>(`${this.apiUrl}/products/ByIds`,ids);
  } 
  
 UpdateProductStatus(id:number,status:UpdateStatusDto): Observable<UpdateStatusResponseDto> {
    return this.http.put<UpdateStatusResponseDto>(`${this.apiUrl}/products/updateStatus/${id}`,status);
  } 
  
   getProductBySlug(slug:string,page: number = 0, storeId: number = 1, userId: number = 1, languageCode: string = 'en'):Observable<FullProductResponseDto>{
    return this.http.get<FullProductResponseDto>(`${this.apiUrl}/products/slug/full?slug=${slug}`);
  }
  getProductsCount(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/products/count`);
  }
// في product.service.ts
searchProducts(
  searchTerm: string,
  page: number = 1,
  pageSize: number = 10
) {
  const params = {
    name: searchTerm.trim(),
    page: page.toString(),
    pageSize: pageSize.toString()
  };

  return this.http.get<any>(
    `${this.apiUrl}/products/search`,
    { params }
  );
}
searchProductsTypeZero(searchTerm: string) {
  const params = {
    name: searchTerm
  };
  
  return this.http.get<any>(`${this.apiUrl}/products/searchTypeZero?`, { params });
}
getReservationProducts(page: number = 0,day : number = 0): Observable<ProductResponseDto> {
    return this.http.get<ProductResponseDto>(`${this.apiUrl}/products/ReservationProducts?page=${page}&day=${day}`);
  }
searchReservationProducts(searchTerm: string, page: number = 1, limit: number = 10,day:number = 0) {
  const params = {
    page: page.toString(),
    limit: limit.toString(),
    name: searchTerm,
    day:day
  };
  
  return this.http.get<any>(`${this.apiUrl}/products/searchReservation?`, { params });
}

// getReservationProductsByDay(day: number, page: number, perPage: number) {
//   const params: any = { page, perPage };
//   params.day = day;

//   return this.http.get(`${this.apiUrl}/products/reservations/day`, { params });
// }

// searchReservationProductsByDay(term: string, day:  number, page: number, perPage: number) {
//   const params: any = { term, page, perPage, day };
//   return this.http.get(`${this.apiUrl}/products/reservations/day/search`, { params });
// }



updateProductQty(payload: {id: number; min_qty: number; prod_qty: number; max_qty: number}) {
  return this.http.put(`${this.apiUrl}/products/${payload.id}/qty`, payload);
}
updateProductStock(id:number ,payload:any) {
  return this.http.put(`${this.apiUrl}/products/${id}/stock`, payload);
}
updateProductType(payload : any) {
  return this.http.post(`${this.apiUrl}/products/Reservation`, payload);
}


updateProduct(productId: number, formData: FormData) {
  return this.http.put(
    `${this.apiUrl}/products/update?productId=${productId}`,
    formData
  );
}
deleteProduct(productId: number): Observable<any> {
  return this.http.delete<any>(`${this.apiUrl}/products/delete?productId=${productId}`);
}

  addProduct( product: FormData) {
 
  // console.log('FormData contents:');
  //   product.forEach((v, k) => console.log(k, v));

  // أرسل formData بدون تحديد Content-Type
  const req = new HttpRequest(
    'POST',
    `${this.apiUrl}/products`,
    product,
    {
      withCredentials: true,
      responseType: 'json'
      // لا تضع headers: Content-Type
    }
  );
  return this.http.request(req);
}
 importFromExcel(file: File, sourceType?: string, branchId?: string, storeId?: string): Observable<any> {
    const url = `${this.apiUrl}/products/import-from-excel`;

    // const headers = new HttpHeaders({
    //   'System-key': '12345678',
    //   'App-Language': 'eg'
    // });

    const formData = new FormData();
    formData.append('File', file);
    if (sourceType) formData.append('SourceType', sourceType);
    if (branchId) formData.append('BranchId', branchId);
    if (storeId) formData.append('StoreId', storeId);

    return this.http.post(url, formData);
  }

}

export enum ProductDiscountFilter {
  All = 0,
  Discounted = 1,
  NotDiscounted = 2
}

export enum ProductImageFilter {
  All = 0,
  WithImage = 1,
  WithoutImage = 2
}

export enum ProductNegativeStockFilter {
  All = 0,
  Enabled = 1,
  Disabled = 2
}

export enum ProductBestSellerFilter {
  All = 0,
  BestSeller = 1,
  NotBestSeller = 2
}

export enum ProductPublishedFilter {
  All = 0,
  Published = 1,
  NotPublished = 2
}